<script setup lang="ts">
import { FormInputSwitch } from "../types";

/////////////////////////////////////////////////////////////
//////////////////////// PROPS //////////////////////////////
/////////////////////////////////////////////////////////////
const props = defineProps<{
  config: FormInputSwitch;
  modelValue: boolean | boolean[] | string[];
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean | boolean[] | string[]): void;
}>();

/////////////////////////////////////////////////////////////
////////////////////// COMPUTED /////////////////////////////
/////////////////////////////////////////////////////////////
const value = computed({
  get: () => props.modelValue,
  set: (value: boolean | boolean[] | string[]) =>
    emit("update:modelValue", value),
});

/////////////////////////////////////////////////////////////
////////////////////// METHODS //////////////////////////////
/////////////////////////////////////////////////////////////
</script>

<template>
  <VSwitch
    v-if="!Array.isArray(value)"
    style="margin-top: 20px"
    v-model="value"
    v-bind="config"
    :disabled="disabled"
  />
  <VSwitch
    v-else
    v-for="v in value"
    v-model="value"
    value="v"
    v-bind="config"
    :label="config.label ? $t(config.label) : undefined"
    :disabled="disabled"
  />
</template>
